module.exports = __webpack_public_path__ + "img/yuyuejiuyi.5a0059ba.png";